export class Controller {

    /** @ngInject */
    constructor($state) {
    	this.$state=$state;
    }

    $onInit() {
    	//if this.licenseViolations from server somehow doesnt have violation $state go to company landing page.
    	this.theViolations=JSON.parse(this.licenseViolations.violationDetails);
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-violation/license-violation.controller.js